"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
export function useServiceWorker() {
  const $ = _c(14);
  const [isOnline, setIsOnline] = useState(true);
  const [isInstallable, setIsInstallable] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [waitingWorker, setWaitingWorker] = useState(null);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const dismissedInstall = localStorage.getItem("pwa-install-dismissed");
      if (typeof window !== "undefined" && "serviceWorker" in navigator) {
        if (process.env.NODE_ENV === "development") {
          navigator.serviceWorker.getRegistrations().then(_temp2);
          if ("caches" in window) {
            caches.keys().then(_temp4);
          }
          return;
        }
        navigator.serviceWorker.register("/sw.js").then(registration_0 => {
          console.log("Service Worker registered:", registration_0);
          setInterval(() => {
            registration_0.update();
          }, 60000);
          registration_0.addEventListener("updatefound", () => {
            const newWorker = registration_0.installing;
            if (newWorker) {
              newWorker.addEventListener("statechange", () => {
                if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
                  console.log("New version available!");
                  setUpdateAvailable(true);
                  setWaitingWorker(newWorker);
                }
              });
            }
          });
        }).catch(_temp5);
        navigator.serviceWorker.addEventListener("message", _temp6);
      }
      const updateOnlineStatus = () => {
        setIsOnline(navigator.onLine);
        if (!navigator.onLine) {
          console.log("Application hors ligne");
        } else {
          console.log("Application en ligne");
        }
      };
      window.addEventListener("online", updateOnlineStatus);
      window.addEventListener("offline", updateOnlineStatus);
      const beforeInstallPromptHandler = e => {
        e.preventDefault();
        setDeferredPrompt(e);
        if (dismissedInstall !== "true") {
          setIsInstallable(true);
        }
      };
      window.addEventListener("beforeinstallprompt", beforeInstallPromptHandler);
      window.addEventListener("appinstalled", () => {
        console.log("PWA install\xE9e avec succ\xE8s");
        setIsInstallable(false);
        setDeferredPrompt(null);
        localStorage.removeItem("pwa-install-dismissed");
      });
      return () => {
        window.removeEventListener("online", updateOnlineStatus);
        window.removeEventListener("offline", updateOnlineStatus);
        window.removeEventListener("beforeinstallprompt", beforeInstallPromptHandler);
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== deferredPrompt) {
    t2 = async () => {
      if (!deferredPrompt) {
        console.log("Prompt non disponible");
        return;
      }
      deferredPrompt.prompt();
      const {
        outcome
      } = await deferredPrompt.userChoice;
      if (outcome === "accepted") {
        console.log("Utilisateur a accept\xE9 l'installation");
        localStorage.removeItem("pwa-install-dismissed");
      } else {
        console.log("Utilisateur a refus\xE9 l'installation");
      }
      setDeferredPrompt(null);
      setIsInstallable(false);
    };
    $[2] = deferredPrompt;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const installPWA = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      localStorage.setItem("pwa-install-dismissed", "true");
      setIsInstallable(false);
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const dismissInstallPrompt = t3;
  let t4;
  if ($[5] !== waitingWorker) {
    t4 = () => {
      if (waitingWorker) {
        waitingWorker.postMessage({
          type: "SKIP_WAITING"
        });
        setUpdateAvailable(false);
        window.location.reload();
      }
    };
    $[5] = waitingWorker;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const updateApp = t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setUpdateAvailable(false);
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const dismissUpdate = t5;
  let t6;
  if ($[8] !== installPWA || $[9] !== isInstallable || $[10] !== isOnline || $[11] !== updateApp || $[12] !== updateAvailable) {
    t6 = {
      isOnline,
      isInstallable,
      installPWA,
      dismissInstallPrompt,
      updateAvailable,
      updateApp,
      dismissUpdate
    };
    $[8] = installPWA;
    $[9] = isInstallable;
    $[10] = isOnline;
    $[11] = updateApp;
    $[12] = updateAvailable;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}
function _temp6(event) {
  if (event.data.type === "SW_UPDATED") {
    console.log("Service Worker updated, reloading...");
    window.location.reload();
  }
}
function _temp5(error) {
  console.error("Service Worker registration failed:", error);
}
function _temp4(names) {
  names.forEach(_temp3);
}
function _temp3(name) {
  caches.delete(name);
  console.log("\uD83D\uDDD1\uFE0F Cache deleted:", name);
}
function _temp2(registrations) {
  for (const registration of registrations) {
    registration.unregister().then(_temp);
  }
}
function _temp() {
  console.log("\uD83D\uDEAB Service Worker unregistered (development mode)");
}